module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner",
    attrs: {
      "id": "banner"
    }
  }, [_vm._t("default"), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.sliders), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      staticClass: "swiper-img",
      attrs: {
        "src": item.imgMUrl,
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "lang"
  }, [(_vm.language == 0) ? _c('div', {
    class: {
      active: _vm.language == 0
    },
    on: {
      "click": function($event) {
        _vm.changeLang(1)
      }
    }
  }, [_vm._v("英文")]) : _vm._e(), _vm._v(" "), (_vm.language == 1) ? _c('div', {
    class: {
      active: _vm.language == 1
    },
    on: {
      "click": function($event) {
        _vm.changeLang(0)
      }
    }
  }, [_vm._v("中文")]) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24bd6344"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/iBanner/iBanner.vue
// module id = 780
// module chunks = 10